import ImgCalendarProvider from '@/components/ImgCalendarProvider';
import IThirdPartyCalendar from '@/types/IThirdPartyCalendar';
import { Box, Flex, Text } from '@chakra-ui/react';
import { OptionProps, components } from 'react-select';

export default function CalendarOption(props: OptionProps<IThirdPartyCalendar>) {
	return (
		<components.Option
			{...props}
			innerProps={{
				...props.innerProps,
				onClick(e) {
					if (props.isDisabled) {
						return;
					}

					if (props.innerProps?.onClick) {
						props.innerProps?.onClick(e);
					}
				},
			}}
		>
			{props.data ? <OptionInner {...props.data} /> : null}
		</components.Option>
	);
}

function OptionInner(props: IThirdPartyCalendar) {
	return (
		<Flex justifyContent="flex-start" alignItems="center" cursor="pointer">
			<ImgCalendarProvider size="4" provider={props.provider} />
			<Box ml={3}>
				<Text fontWeight={500} fontSize="xs">{props.name}</Text>
				<Text fontSize="xs">{props.account}</Text>
			</Box>
		</Flex>
	);
}
